import * as React from 'react';
import * as styles from './Main.css';

export const Main: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <main className={styles['main']}>{children}</main>;
};
